
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign-up/details",
      function () {
        return require("private-next-pages/sign-up/details.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign-up/details"])
      });
    }
  